/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Styled components
 */
export default styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-left: -${scale.major(1)}px;
  margin-top: -${scale.major(1)}px;
  padding-left: ${scale.major(1)}px;
  padding-right: ${scale.major(1)}px;
  > span {
    margin-left: ${scale.major(1)}px;
    margin-top: ${scale.major(1)}px;
  }
`;
